export const InboxesListName = 'inboxesListComponent';
